import React, { useState} from "react";
import ButtonGroup, { ButtonOption } from "@amzn/meridian/button-group"
import Heading from "@amzn/meridian/heading";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import {FormattedMessage} from "react-intl";
import {StoreReconciliationSheet} from "./storeReconciliationSheet/StoreReconciliationSheet";
import {TransferSheet} from "./transferSheet/TransferSheet";
import {DepartureSheet} from "./departureSheet/DepartureSheet";
import {LabelSheet} from "./labelSheet/LabelSheet";
import {VirtualDepartDriver} from "./virtualDepartDriver/VirtualDepartDriver";
import {useFeatures} from "./handler/DynamicConfigHandler";
import {FeatureConstants} from "./constants/FeatureConstants";
import {DriverPackageSummary} from "./driverPackageSummary/driverPackageSummary";
import {EwayBill} from "./eWayBill/EwayBill";

export const SearchView = (props) => {
    const [currentTab, setCurrentTab] = useState("transferSheet");
    const featureStatusMap = (useFeatures([FeatureConstants.ADHOC_PRINT_ENABLED, FeatureConstants.VIRTUAL_DEPART_DRIVER_ENABLED,
    FeatureConstants.DRIVER_PACKAGE_SUMMARY_TAB_ENABLED, FeatureConstants.EWAY_BILL_TAB_ENABLED]))[1]
    const isLabelSheetActive = featureStatusMap && featureStatusMap[FeatureConstants.ADHOC_PRINT_ENABLED] ?
        featureStatusMap[FeatureConstants.ADHOC_PRINT_ENABLED] : false;
    const isVirtualDepartDriverEnabled = featureStatusMap && featureStatusMap[FeatureConstants.VIRTUAL_DEPART_DRIVER_ENABLED] ?
        featureStatusMap[FeatureConstants.VIRTUAL_DEPART_DRIVER_ENABLED] : false;
    const isDriverPackageSummaryTabEnabled = featureStatusMap && featureStatusMap[FeatureConstants.DRIVER_PACKAGE_SUMMARY_TAB_ENABLED] ?
        featureStatusMap[FeatureConstants.DRIVER_PACKAGE_SUMMARY_TAB_ENABLED] : false;
    const isEwayBillTabEnabled = featureStatusMap && featureStatusMap[FeatureConstants.EWAY_BILL_TAB_ENABLED] ?
        featureStatusMap[FeatureConstants.EWAY_BILL_TAB_ENABLED] : false;

    return (
        <Column spacingInset="small none none none">
            <Row spacingInset="large large medium large">
                <Heading type="d50" level={1}>
                    <FormattedMessage id="search.search" defaultMessage="Print Depart"/>
                </Heading>
            </Row>
            <Row spacingInset="none large">
                <ButtonGroup value={currentTab} onChange={setCurrentTab} type="fill">
                    <ButtonOption value="transferSheet">
                        <FormattedMessage id="search.transferSheet" defaultMessage="Transfer Sheet"/>
                    </ButtonOption>
                    <ButtonOption value="storeReconciliationSheet">
                        <FormattedMessage id="search.storeReconciliationSheet" defaultMessage="Store Reconciliation Sheet"/>
                    </ButtonOption>
                    <ButtonOption value="departureSheet">
                        <FormattedMessage id="search.departureSheet" defaultMessage="Departure Sheet"/>
                    </ButtonOption>
                    {
                        isLabelSheetActive &&
                        <ButtonOption value="labelSheet">
                            <FormattedMessage id="search.labelSheet" defaultMessage="Label Sheet"/>
                        </ButtonOption>
                    }
                    {
                        isVirtualDepartDriverEnabled &&
                        <ButtonOption value="virtualDepartDriver">
                            <FormattedMessage id="virtual.depart.driver" defaultMessage="Virtual Depart Driver"/>
                        </ButtonOption>
                    }
                    {
                        isDriverPackageSummaryTabEnabled &&
                        <ButtonOption value="driverPackageSummary">
                            <FormattedMessage id="driver.package.summary" defaultMessage="Driver Package Summary"/>
                        </ButtonOption>
                    }
                    {
                        isEwayBillTabEnabled &&
                        <ButtonOption value="eWayBill">
                            <FormattedMessage id="search.eWayBill" defaultMessage="E-way Bill"/>
                        </ButtonOption>
                    }
                </ButtonGroup>
            </Row>
            {currentTab === "transferSheet" ? <TransferSheet/> :
                currentTab === "storeReconciliationSheet" ? <StoreReconciliationSheet/> :
                    currentTab === "departureSheet" ? <DepartureSheet/> :
                        currentTab === "labelSheet" ? <LabelSheet/> :
                            currentTab === "virtualDepartDriver" ? <VirtualDepartDriver/> :
                                currentTab === "driverPackageSummary" ? <DriverPackageSummary/> :
                                    currentTab === "eWayBill" ? <EwayBill/> :
                                        <StoreReconciliationSheet/>}
        </Column>
    )
}



// WEBPACK FOOTER //
// ./src/components/SearchView.js